module.exports = __webpack_public_path__ + "media/images/breadcrumb/errors404-940ef0eaa12353b4b4058434c6a58b84.png";